module.exports = __webpack_public_path__ + "img/brian-kelly.b180886c.jpg";